import { PhoneArrowDownLeftSolidV6 } from "@shared/v2/Icomoon";

import ActivityContainer from "./ActivityContainer";
import { activityCommonDefaultProps, activityCommonPropTypes, STYLES } from "../common";
import Header from "./Header";
import CategoryContainer from "./CategoryContainer";

const TrackingNumberCallActivity = ({ activity, onReadChange }) => (
  <ActivityContainer
    activity={activity}
    onReadChange={onReadChange}
    specificLink={`/phone_system?view=logs&call_log_id=${activity.data?.trackingNumberCallId}`}
  >
    <Header
      category={
        <CategoryContainer
          containerClassName="tw-bg-[#FAF1E6] tw-text-[#AD6714]"
          Icon={PhoneArrowDownLeftSolidV6}
        >
          New Call
        </CategoryContainer>
      }
      personName={`${activity.data.contactName} to ${activity.data.trackingNumberName}`}
      time={activity.createdAt}
      onReadChange={onReadChange}
      loading={activity.loading}
      read={activity.read}
    />
    <div className={`${STYLES.contentContainer} tw-text-14d`}>
      <span className={`${STYLES.lineClamp3} tw-px-8px`}>{activity.content}</span>
    </div>
  </ActivityContainer>
);

export default TrackingNumberCallActivity;

TrackingNumberCallActivity.propTypes = {
  ...activityCommonPropTypes,
};

TrackingNumberCallActivity.defaultProps = {
  ...activityCommonDefaultProps,
};
